"use client";

import { usePathname } from "next/navigation";
import { routeUtils } from "@/lib/constants/routes";

interface ConditionalLayoutProps {
  children: React.ReactNode;
  header: React.ReactNode;
}

export default function ConditionalLayout({
  children,
  header,
}: ConditionalLayoutProps) {
  const pathname = usePathname();

  // Use centralized route utilities
  const isMinimalLayout = routeUtils.isMinimalLayout(pathname);

  if (isMinimalLayout) {
    return <>{children}</>;
  }

  return (
    <main className="min-h-screen flex flex-col">
      {header}
      <div className="flex-1 flex flex-col">
        {children}

        <footer className="w-full flex items-center justify-center border-t mx-auto text-center text-xs gap-8 py-4">
          <p>
            <a
              href="https://www.onairgameshows.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold hover:underline transition-colors"
            >
              Visit On Air Game Shows
            </a>
          </p>
        </footer>
      </div>
    </main>
  );
}
